import React, { Component } from "react";
import RiskMgmtTable from "./RiskMgmtTable";
import RiskSummaryView from "./RiskSummaryView";


class RiskMgmtView extends Component {
  render() {
    return (
      <div className="ticket-body">
        <RiskSummaryView />
        <hr />
        <RiskMgmtTable />
      </div>
    );
  }
}

export default RiskMgmtView;



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/RiskMgmtView.js